<template>
  <div class="content-wrapper">
    <ContentHeader
      _title="`Карта № &quot;${companyName}&quot;`"
      :title="`Карта № ${cardNumber}`"      
    >
        <template slot="additional-header-info" v-if="getCardUserSucceeded"> 
            <span class="tag tag-default bg-warning bg-red bg-darken-2" v-if=" getCardById( getCardUser.card_id ).block==true">Заблокирована</span>
        </template>
    </ContentHeader>    
    <div class="content-body">
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-xs-12">
          <div class="card">
            <div class="card-body">
              <div class="media">
                <!--div class="p-1 text-xs-center bg-indigo bg-darken-1 media-left media-middle">
                                <i 
                                class="icon-qrcode font-large-2 white"
                                ></i>
                            </div-->
                <div class="p-1 media-body">
                  <h5 style="text-transform: uppercase; font-weight: 700">
                    QR-код карты
                  </h5>

                  <div class="qrcode-container">
                    <vue-qrcode
                      class="qrcode"
                      :value="cardQRstring"
                      :width="width"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BalanceCard
          header="Остаток в литрах"
          subHeader=""
          iconClass="icon-speedometer"
          _path="1"
          :balances="cardFuelBalances"
          :loading="getCardUserLoading"
          v-if="getCardUser.fuel_enabled"
        />

        <BalanceCard
          header="Денежный остаток"
          subHeader=""
          iconClass="icon-banknote"
          _path="1"
          :balances="cardMoneyBalances"
          :loading="getCardUserLoading"
          v-if="getCardUser.money_enabled"
        />
        <div class="col-xs-12">
          <BillTable
            title="ДЕТАЛИЗАЦИЯ КАРТЕ"
            topCaption
            :itemsPerPage="10"
            :fields="fields"
            :items="getTransactions"
            :filterIncludedFields="filterOn"
            :filter="
              searchText || dateFrom || dateTo
                ? { searchText, dateFrom, dateTo }
                : null
            "
            :filterFunction="filterTransactions"
            :busy="isCardsTransactionsLoading"
            :failed="isCardsTransactionsFailed"
            @reload="reloadTransactions"
          >
            <template slot="top">
              <div class="card-block">
                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          class="form-control bg-grey bg-lighten-4"
                          placeholder="Поиск по детализации"
                          v-model="searchText"
                        />
                        <div class="form-control-position">
                          <i class="icon-search4"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <datepicker
                        format="DD.MM.YYYY"
                        placeholder="Искать после"
                        input-class="form-control bg-grey bg-lighten-4"
                        style="width: 100%"
                        v-model="dateFrom"
                      ></datepicker>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <datepicker
                        format="DD.MM.YYYY"
                        placeholder="Искать до"
                        input-class="form-control bg-grey bg-lighten-4"
                        style="width: 100%"
                        v-model="dateTo"
                      ></datepicker>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </BillTable>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import ContentHeader from "@/components/ContentHeader.vue";
//import card from "@/components/card.vue";
import BalanceCard from "@/components/BalanceCard.vue";
import VueQrcode from "vue-qrcode";
import BillTable from "@/components/BillTable";

import { mapGetters } from "vuex";

import {
  CARDS_CARD_USER_REQUEST,
  CARDS_TRANSACTIONS_REQUEST,
  CARDS_REQUEST,
} from "@/store/actions/cards";

export default {
  name: "Main",
  components: {
    ContentHeader,

    BalanceCard,
    VueQrcode,
    BillTable,
  },

  computed: {
    ...mapGetters([
      "getCardUserLoading",
      "getCardUserFailed",
      "getCardUserSucceeded",
      "cardsUserOnceLoaded",

      "getCardUser",
      "getCardById",
      "cardsOnceLoaded",

      "getTransactions",
      "cardsTransactionsOnceLoaded",
      "isCardsTransactionsLoading",
      "isCardsTransactionsFailed",
      "getCurrencyName",
    ]),
    cardFuelBalances() {
      let balances = [];
      if (this.getCardUser.fuels)
        this.getCardUser.fuels.forEach((f) => {
          balances.push({ title: f.product_name, value: f.quantity });
        });
      return balances;
    },
    cardMoneyBalances() {
      let balances = [];
      if (this.getCardUser.money)
        balances.push({ title: "Тенге", value: this.getCardUser.money });
      return balances;
    },
    cardQRstring() {
      if (this.getCardUser.card_id) 
        return this.getCardUser.card_id + "";

      return "????";
    },
    cardNumber() {
      if (this.getCardUser.card_id) 
        return this.getCardUser.card_id + "";

      return "?";
    },
    companyName() {
      return this.getCardUser.client_name ?? "";
    },
    filteredTransactions() {
      if (!(this.searchText || this.dateFrom || this.dateTo)) {
        return this.getTransactions;
      } else {
        const filter = {
          searchText: this.searchText,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        };
        return this.getTransactions.filter((t) =>
          this.filterTransactions(t, filter)
        );
      }
    },
  },

  data() {
    return {
      qrcodeValue: "",
      qrcodeShow: false,
      width: 100,

      searchText: null,
      dateFrom: null,
      dateTo: null,
      fields: [
        {
          key: "date",
          label: "Дата",
          formatter: (value, key, item) => {
            return new Date(item.sdate).toLocaleDateString();
          },
          filterByFormatted: true,
        },
        {
          key: "time",
          label: "Время",
          formatter: (value, key, item) => {
            return new Date(item.sdate).toLocaleTimeString();
          },
          filterByFormatted: true,
        },
        {
          key: "azs",
          label: "АЗС",
          formatter: (value, key, item) => {
            return `АЗС №${value} ${item.region}`;
          },
          filterByFormatted: true,
        },
        {
          key: "type",
          label: "Баланс списания",
          formatter: (value) => {
            return value === 0 ? "Литровый" : "Денежный";
          },
          filterByFormatted: true,
        },
        {
          key: "product",
          label: "Товар",
        },

        {
          key: "quantity",
          label: "Количество",
          type: Number,
        },
        {
          key: "cost",
          label: "Сумма",
          type: Number,
        },
      ],
      filterOn: [
        "card_id",
        "holder_name",
        "azs",
        "product",
        "quantity",
        "cost",
      ],
    };
  },

  created() {
    //if (!this.cardsTransactionsOnceLoaded)
      this.$store.dispatch(CARDS_TRANSACTIONS_REQUEST);

    if (!this.cardsOnceLoaded)
      this.$store.dispatch(CARDS_REQUEST)
        .then(() => {
            if (!this.cardsUserOnceLoaded) this.$store.dispatch(CARDS_CARD_USER_REQUEST);
        });

    //if (!this.cardsUserOnceLoaded)
        this.$store.dispatch(CARDS_CARD_USER_REQUEST);

  },
  mounted() {
    this.handleOrientationChange();
    window.addEventListener("orientationchange", this.handleOrientationChange);
  },
  methods: {
    handleOrientationChange() {
      const orientation = window.screen.orientation.type;
      let maxWidth = 300;
      if (orientation === "portrait-primary") {
        this.width =
          window.screen.availWidth < maxWidth
            ? window.screen.availWidth
            : maxWidth;
      } else if (orientation === "landscape-primary") {
        this.width =
          window.screen.availHeight < maxWidth
            ? window.screen.availHeight
            : maxWidth;
      }
    },

    reloadTransactions() {
      this.$store.dispatch(CARDS_TRANSACTIONS_REQUEST);
    },
    filterTransactions(tr, filter) {
      if (!filter) return;

      let d = new Date(tr.sdate);
      if (filter.dateFrom && d < filter.dateFrom) return false;
      if (filter.dateTo && d > filter.dateTo) return false;

      if (!filter?.searchText) return true;
      let rex = new RegExp(filter.searchText, "i");
      for (let i = 0; i < this.filterOn.length; i++) {
        const fname = this.filterOn[i];
        if (rex.test(String(tr[fname]))) return true;
      }
    },
  },
};
</script>

<style scoped>
.qrcode {
  object-fit: contain;
  max-width: 512px;
  margin: auto;
}
.qrcode-container {
  /*display: flex;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;*/
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>